import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { API_CALLS } from "../../../API/api_calls";
import { useAppSelector } from "../../../redux";
import { ROUTES } from "../../../utills/routes";
import { ArticlePageProps } from "./Article";
import ArticleContent from "./content";
import CoverImage from "./coverImage";
import MediaDropDown from "./mediaDropDown";
import ArticleTitle from "./title";
import Toolbar from "./toolbar";

export const ArticleContext = createContext({} as ArticlePageProps.Context);

export const Article = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const articleId = params.get("article_id");

  const [focusedEditor, setFocusedEditor] = useState("");
  const [editors, setEditors] = useState<ArticlePageProps.EditorMap>({});
  const { isArticleFullScreen } = useAppSelector((state) => state.common);
  const { createDraftAPI_STATUS, publishedArticleList } = useAppSelector(
    (state) => state.article
  );
  const [floatingAnchorElem, setFloatingAnchorElem] =
    useState<HTMLDivElement | null>(null);

  const contextValue = {
    editors,
    setEditors,
    focusedEditor,
    setFocusedEditor,
    floatingAnchorElem,
    setFloatingAnchorElem,
  };

  useEffect(() => {
    API_CALLS.ARTICLE.listPublishedArticles();
    if (articleId) {
      API_CALLS.ARTICLE.getASingleArticleDraft(articleId, navigate);
    } else {
      API_CALLS.ARTICLE.createArticleDraft();
    }
  }, [articleId, navigate]);

  useEffect(() => {
    const isPublished =
      publishedArticleList.findIndex((item) => item.id === articleId) >= 0;
    if (isPublished) {
      navigate(ROUTES.article);
    }
  }, [publishedArticleList, articleId, navigate]);

  if (createDraftAPI_STATUS !== "success") return <>loading</>;

  return (
    <ArticleContext.Provider value={contextValue}>
      <Toolbar />
      <Container $isFullScreen={isArticleFullScreen}>
        <CoverImage />
        <ArticleTitle />
        <ArticleContent />
        <MediaDropDown />
      </Container>
    </ArticleContext.Provider>
  );
};

const Container = styled.div<{ $isFullScreen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  padding: ${({ $isFullScreen, theme }) =>
      $isFullScreen
        ? ThisGorillaUtils.convertPxToRem("88")
        : theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${ThisGorillaUtils.convertPxToRem("100")}rem;
  min-height: calc(
    100vh -
      ${({ theme, $isFullScreen }) =>
        $isFullScreen
          ? theme.spacing["spacing-none"].value
          : ThisGorillaUtils.convertPxToRem("161")}rem
  );
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
